import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "phone",
  "use": "phone-usage",
  "viewBox": "0 0 23 22",
  "content": "<symbol viewBox=\"0 0 23 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"phone\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 9.351c1.74 3.322 4.543 6.033 7.962 7.736l2.658-2.583c.327-.317.81-.422 1.233-.282 1.353.435 2.815.67 4.314.67.664 0 1.208.528 1.208 1.173v4.097c0 .646-.544 1.174-1.208 1.174C9.82 21.336.625 12.403.625 1.38c0-.646.544-1.174 1.208-1.174h4.23c.664 0 1.208.528 1.208 1.174 0 1.467.242 2.876.689 4.19.132.411.036.87-.303 1.198L5 9.35z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id